export class ModalidadXDestino {
  constructor(
    public idModalidad: Number,
    public idDestino: Number,
    public idCliente: Number,
  ) { }
}
